
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Loader from '@/components/Loader.vue';
import Seller from '@/domain/sellers/Seller';
import Fee from '@/domain/fees/Fee';

const FeeBreakdownChart = () =>
  ({
    component: import(/* webpackChunkName: "charting" */ '@/components/FeeBreakdownChart.vue'),
    loading: Loader,
  } as any);

@Component({
  components: {
    FeeBreakdownChart,
  },
})
export default class SellerComission extends Vue {
  @Prop() public seller!: Seller;
  @Prop() public price!: number;
  @Prop() public hours!: number;

  get sellerFee(): number {
    return this.seller.totalFee(this.price, this.hours);
  }

  get sellerFees(): Fee[] {
    return this.seller.feesTaken(this.price, this.hours);
  }

  get propertyPercentage(): string {
    return ((this.sellerFee / this.price) * 100).toFixed(2);
  }

  public openIconClasses = {
    'open-icon': true,
    'open-icon-closed': true,
    'open-icon-open': false,
  };

  public expanded = false;

  public expand(): void {
    this.expanded = !this.expanded;
    this.openIconClasses['open-icon-closed'] = !this.expanded;
    this.openIconClasses['open-icon-open'] = this.expanded;
  }
}
